module.exports = __webpack_public_path__ + "img/2-3.21f994ec.png";